let config = {};

config.windowRoot = "https://cycleplanner.betterbybike.info";
config.websiteUrl = "https://betterbybike.info";
config.windowPort = "";

export default config;



// WEBPACK FOOTER //
// ./src/config.js